enum TutorMessagesTab {
	Answers,
	Questions,
}

export default TutorMessagesTab;
